import { useIsDesktopDimension, useManyRefs } from '@carnica/utils/hooks';
import { useCallback, useEffect, useRef } from 'react';
import { useScrollContext } from "../../../../../shared/model";
import { useScrollDetector } from "../../../../../shared/lib";
import { isSectionInView, isStartDiverMove } from "./utils";
export var useStickyDividers = function useStickyDividers(groupedMessages) {
  var sessionsCount = groupedMessages.length;
  var dividerRefs = useManyRefs(sessionsCount);
  var sessionSectionRefs = useManyRefs(sessionsCount);
  var _useScrollContext = useScrollContext(),
    scrollRef = _useScrollContext.scrollRef;
  var moveDividerFlags = useRef(new Array(sessionsCount).fill(false));
  var isDesktop = useIsDesktopDimension();
  var detectPositions = function detectPositions() {
    if (!scrollRef.current) {
      return;
    }
    moveDividerFlags.current = sessionSectionRefs.map(function (sectionRef, i) {
      return isSectionInView(scrollRef, sectionRef, isDesktop) && isStartDiverMove(dividerRefs[i], sectionRef);
    });
  };
  var onScrollAction = useCallback(function (type) {
    return function () {
      moveDividerFlags.current.forEach(function (flag, i) {
        var ref = dividerRefs[i];
        if ((type === 'stop' ? flag : true) && ref !== null && ref !== void 0 && ref.current) {
          ref.current.style.opacity = type === 'stop' ? '0' : '1';
        }
      });
    };
  }, [sessionsCount]);
  useEffect(detectPositions, [sessionsCount]);
  useScrollDetector(scrollRef, {
    onScroll: detectPositions,
    deps: [sessionsCount],
    onStopScrolling: onScrollAction('stop'),
    onStartScrolling: onScrollAction('start')
  });
  return {
    dividerRefs: dividerRefs,
    sessionSectionRefs: sessionSectionRefs
  };
};